import React, { useEffect, useState } from 'react'
import { getStatus } from '../../helperFunction/status';
import { Link, useNavigate } from 'react-router-dom';
function ClaimRowMobile({ status, data, apiCallHandler1, apiCallHandler }) {
    const navigate = useNavigate()
    const [curruntStatus, setCurruntStatus] = useState();
    useEffect(() => {
        if (data) {
            const taskData = {
                ...data.task,
                isClaimed: data.isClaimed,
                outerStatus: data.status,
            };
            const status = getStatus(taskData, 'taskParticipated');
            setCurruntStatus(status);
            // console.log(status, 'yyyyyyyyyy');
        }
    }, [data]);
    const handleClaim = () => {
        if (data?.task?.disputeWinnerId) {
            apiCallHandler1(data);
        } else {
            apiCallHandler(data);
        }
    };
    return (
        <>
            {curruntStatus?.status === 'Winner Determined' ? (
                <button className="tasksubmitwithdraw " onClick={handleClaim}>
                    Withdraw
                </button>
            ) : curruntStatus?.status === 'live' && data?.status !== 'submitted' ? (
                      <button onClick={() => navigate(`/similartaskdetail/${data?.task?.id}`)}  className="tasksubmit text-decoration-none" >
                 Submit Task
                </button> 
           ) : curruntStatus?.status === 'inDisputePeriod' && data?.status !== 'winner' && data?.status !== 'disputed' ? ( 
                        <button onClick={() => navigate(`/similartaskdetail/${data?.task?.id}`)} className="tasksubmitred w-100 text-decoration-none" >
                    Create Dispute
                </button>
            ) : null} 
        </>
    );
}

export default ClaimRowMobile;
